import * as Sentry from '@sentry/nextjs';
import { nodeEnv } from './services/request';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: process.env.SENTRY_RELEASE || 'enigma-pwa@local',
  enabled:
    process.env.NODE_ENV === 'production' &&
    process.env.NEXT_PUBLIC_ENV !== 'test',
  environment: nodeEnv,

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.1,
  // Enable logs to be sent to Sentry
  enableLogs: false,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  ignoreErrors: [
    'Non-Error promise rejection captured',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
    'Socket encountered error: undefined',
    "expected expression, got '<'",
    "Unexpected token '<'",
    'Rejected',
    /ServiceWorker/i, // when user lose his connection sw still work and create some errors
    'Script https://pwa.enigma.ir/sw.js load failed',
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
